module.exports = {"410104001":"北下街街道","410104002":"西大街街道","410104003":"南关街道","410104004":"城东路街道","410104005":"东大街街道","410104006":"二里岗街道","410104007":"陇海马路街道","410104008":"紫荆山南路街道","410104009":"航海东路街道","410104010":"十八里河街道","410104201":"南曹乡","410104202":"圃田乡","410104570":"商都路街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410104.json
// module id = 1515
// module chunks = 0